import React, { FC } from "react";
import { TooltipPlacementEnum, TooltipTriggerEnum } from "enums/enums";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Const from '../../../const.json';
import infoIcon from '../../../assets/icons/info.svg';
import "./CustomTooltip.scss";

const CustomTooltip: FC<{
  content: string;
  placement?: TooltipPlacementEnum;
  elementOn?: React.ReactElement;
  trigger?: TooltipTriggerEnum | TooltipTriggerEnum[];
}> = ({ content, placement = TooltipPlacementEnum.Top, elementOn, trigger = [TooltipTriggerEnum.Hover, TooltipTriggerEnum.Focus] }) => {
  return (
    <div className="d-inline m-2">
      <OverlayTrigger
        placement={placement}
        delay={{ show: 500, hide: 0 }}
        overlay={(props) => <Tooltip tabIndex={0} id="tooltip-content" aria-label={content} {...props}>{content}</Tooltip>}
        trigger={trigger}
      >
        {elementOn ?? <img
          className="infoIcon"
          src={infoIcon}
          tabIndex={0}
          aria-label={Const.info}
          aria-labelledby="tooltip-content"
        />}
      </OverlayTrigger>
    </div>
  );
};

export default CustomTooltip;
